import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiHandler } from '../../api/apihandler';
import { PROFILE_DETAILS } from '../../api/constants';
import { apiSucceeded, getAvatarColor, getInitials } from '../../views/dashboard/feed/feedUtils';

// Real "your activity" snapshot for the right rail - replaces the static
// Quick Links nav with something that actually reflects the signed-in
// user (same PROFILE_DETAILS call my-profile-page.js uses).
const MyStatsWidget = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  // posted_challenges_count/participated_challenges_count come back as
  // siblings of `user` on PROFILE_DETAILS, not nested inside it.
  const [challengeCount, setChallengeCount] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const res = await apiHandler(PROFILE_DETAILS, 'POST');
        if (apiSucceeded(res)) {
          const data = res?.data?.data;
          setProfile(data?.user);
          setChallengeCount((data?.posted_challenges_count ?? 0) + (data?.participated_challenges_count ?? 0));
        }
      } catch (e) { console.error(e); }
    })();
  }, []);

  if (!profile) return null;

  const name = `${profile?.first_name || ''} ${profile?.last_name || ''}`.trim() || 'You';

  return (
    <div className="nmsl-rail-block">
      <div className="nmsl-rail-head"><h3>Your activity</h3></div>
      <div
        className="nmsl-card nmsl-clickable"
        style={{ marginBottom: 12 }}
        onClick={() => navigate('/dashboard/app/profile')}
      >
        {profile?.user_setting?.photo ? (
          <img src={profile.user_setting.photo} alt={name} className="nmsl-avatar" />
        ) : (
          <div className="nmsl-avatar" style={{ background: getAvatarColor(name) }}>
            {getInitials(...name.split(' '))}
          </div>
        )}
        <div className="nmsl-body">
          <div className="nmsl-name">{name}</div>
          <div className="nmsl-sub">View your profile</div>
        </div>
      </div>
      <div className="nmsl-stats-card">
        <div className="nmsl-stat-cell nmsl-clickable" role="button" tabIndex={0} onClick={() => navigate('/dashboard/app/profile', { state: { tab: 'recipes' } })}>
          <div className="nmsl-stat-num">{profile?.post_count ?? 0}</div>
          <div className="nmsl-stat-label">Recipes</div>
        </div>
        <div className="nmsl-stat-cell nmsl-clickable" role="button" tabIndex={0} onClick={() => navigate('/followers')}>
          <div className="nmsl-stat-num">{profile?.follower_count ?? 0}</div>
          <div className="nmsl-stat-label">Followers</div>
        </div>
        <div className="nmsl-stat-cell nmsl-clickable" role="button" tabIndex={0} onClick={() => navigate('/following')}>
          <div className="nmsl-stat-num">{profile?.following_count ?? 0}</div>
          <div className="nmsl-stat-label">Following</div>
        </div>
        <div className="nmsl-stat-cell nmsl-clickable" role="button" tabIndex={0} onClick={() => navigate('/dashboard/app/profile', { state: { tab: 'challenges' } })}>
          <div className="nmsl-stat-num">{challengeCount}</div>
          <div className="nmsl-stat-label">Challenges</div>
        </div>
      </div>
    </div>
  );
};

export default MyStatsWidget;
